import { frontendURL } from '../../../helper/URLHelper';
import store from '../../../store';
import MenuVisibilityView from './pages/MenuVisibilityView.vue';

// Defesa extra além de esconder o item no menu: mesmo que alguém acesse
// a URL direto, só entra quem for Super Admin de verdade (tipo de
// usuário, não papel de conta — ver useSuperAdmin.js).
const redirectIfNotSuperAdmin = (to, _from, next) => {
  const currentUser = store.getters.getCurrentUser;
  if (currentUser?.type === 'SuperAdmin') {
    next();
    return;
  }
  next({ name: 'home', params: { accountId: to.params.accountId } });
};

const menuVisibilityRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/menu-visibility'),
      name: 'menu_visibility_settings',
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: redirectIfNotSuperAdmin,
      component: MenuVisibilityView,
    },
  ],
};

export default menuVisibilityRoutes;
